export default {
  kicker: 'Mehr',
  title: 'Ausrüstung',
  loading: 'Lädt …',
  loadError: 'Ausrüstung nicht geladen: {error}',
  active: 'Aktiv',
  retired: 'Ausgemustert',
  empty: 'Noch keine Schuhe. Lege einen an – oder importiere deinen Strava-Export.',
  add: 'Neuer Schuh',
  edit: 'Bearbeiten',
  save: 'Speichern',
  cancel: 'Abbrechen',
  delete: 'Löschen',
  deleteConfirm: {
    one: 'Löschen nimmt den Schuh aus {count} Aktivität. Sie zählt dann ohne Schuh und wird nicht noch einmal abgefragt. Das lässt sich nicht rückgängig machen – wer die km behalten will, mustert aus.',
    other: 'Löschen nimmt den Schuh aus {count} Aktivitäten. Sie zählen dann ohne Schuh und werden nicht noch einmal abgefragt. Das lässt sich nicht rückgängig machen – wer die km behalten will, mustert aus.',
  },
  deleteYes: 'Endgültig löschen',
  retire: 'Ausmustern',
  unretire: 'Zurückholen',
  retireHint: 'Ausmustern: Der Schuh bleibt mit seinen km im Archiv, wird aber nicht mehr angeboten und warnt nicht mehr.',
  unretireHint: 'Zurückholen: Der Schuh wird wieder angeboten und warnt wieder.',
  name: 'Name',
  namePlaceholder: 'z. B. HOKA Clifton 9',
  startKm: 'km vorher',
  startKmHelp: 'Schon gelaufen, bevor dashy-dash den Schuh kannte',
  warnKm: '„Bald ersetzen" ab km',
  limitKm: '„Ersetzen" ab km',
  limitHelp: 'Laufschuhe halten meist 500–800 km. Leer = keine Grenze.',
  noLimit: 'leer = keine',
  counts: 'Gezählt werden Laufen, Gehen und Wandern mit dem Schuh, dazu die km vorher.',
  uses: { one: '{count} Aktivität', other: '{count} Aktivitäten' },
  range: 'gelaufen {from} – {to}',
  ofStart: 'davon {km} vorher',
  retiredOn: 'ausgemustert {date}',
  unused: 'noch nicht benutzt',
  status: { warn: 'Bald ersetzen', limit: 'Ersetzen' },
  toWarn: 'noch {km} bis „Bald ersetzen" ({at})',
  toLimit: 'noch {km} bis „Ersetzen" ({at})',
  overLimit: '{km} über {at}',
  retiredShow: { one: 'Ausgemustert ({count}) anzeigen', other: 'Ausgemustert ({count}) anzeigen' },
  profile: {
    typical: 'typisch {km} bei {pace} (Median aus {count} Läufen)',
    hr: 'Ø Puls {hr}',
    rhythm: 'am häufigsten {day} ({share}), {daytime}',
    days: { 0: 'montags', 1: 'dienstags', 2: 'mittwochs', 3: 'donnerstags', 4: 'freitags', 5: 'samstags', 6: 'sonntags' },
    daytime: { morning: 'morgens', midday: 'mittags', afternoon: 'nachmittags', evening: 'abends', night: 'nachts' },
    fastestKm: 'schnellster km {time}',
    longest: 'längster Lauf {km}',
    temp: 'Ø {temp}',
    wet: { one: 'Regen bei {count} von {of} Läufen', other: 'Regen bei {count} von {of} Läufen' },
    tooNew: 'Steckbrief ab {count} Läufen',
    forecast: 'bei {perWeek} pro Woche (letzte 90 Tage) etwa {month}',
    pause: '(zuletzt gelaufen am {date})',
    resting: 'zuletzt gelaufen am {date}, daher keine Prognose',
    restingWorn: 'zuletzt gelaufen am {date} – ausmustern? Das geht unter „Bearbeiten".',
    slow: 'in den letzten 90 Tagen nur {km} – zu wenig für eine Prognose',
    story: 'Rückblick',
    storyAria: 'Rückblick: {name}',
  },
  charts: {
    kmTitle: 'km je Schuh',
    kmSub: 'Aktive Schuhe ab dem ersten Lauf, mit den km vorher',
    timeSub: 'Vom ersten bis zum letzten Lauf mit dem Schuh',
    view: 'Ansicht',
    viewKm: 'km',
    viewTime: 'Wann im Einsatz',
    xKm: 'Jahre im Einsatz',
    active: 'aktiv',
    retired: 'ausgemustert',
    forecast: 'Prognose aus den letzten 90 Tagen',
    wornBand: 'hier hast du bisher ausgemustert',
    idle: 'aktiv, aber seitdem nicht gelaufen',
    lastRun: 'zuletzt {date}',
    tipKm: '{km} nach {months} Monaten',
    tipForecast: '„Bald ersetzen" etwa {month}',
    tipForecastLimit: '„Ersetzen" etwa {month}',
    kmTakeaway: { one: 'Den {count} Schuh, der über {min} km kam, hast du bei {from} ausgemustert.', other: 'Die {count} Schuhe, die über {min} km kamen, hast du zwischen {from} und {to} ausgemustert.' },
    timeTakeaway: 'Am längsten im Einsatz: {name}, {months} Monate.',
    chartLabel: 'km je aktivem Schuh über die Jahre im Einsatz, mit Prognose',
    paceTitle: 'Tempo je Schuh',
    paceSub: 'Schuhe ab 10 Läufen. Der Balken zeigt, wie schnell die Hälfte deiner Läufe war, der Strich das typische Tempo. Links ist schneller.',
    paceTakeaway: 'Mit dem {fast} läufst du typisch am schnellsten ({fastPace}), mit dem {slow} am lockersten ({slowPace}).',
    paceRow: '{name}: {count} Läufe, typisch {pace}, die mittlere Hälfte zwischen {from} und {to}',
    paceMeta: { one: '{pace} · {count} Lauf', other: '{pace} · {count} Läufe' },
  },
  story: {
    kicker: 'Schuh-Rückblick',
    km: 'Kilometer',
    runs: { one: '{count} Lauf', other: '{count} Läufe' },
    walks: { one: ' und {count} Mal Gehen oder Wandern', other: ' und {count} Mal Gehen oder Wandern' },
    span: '{runs}{walks}, {from} bis {to}.',
    spanActive: '{runs}{walks} seit {from} – und noch im Einsatz.',
    elevation: 'Höhenmeter',
    hours: 'Stunden unterwegs',
    months: 'Monate',
    rhythmKicker: 'Rhythmus',
    rhythmTitle: 'Am liebsten {day}, {daytime}',
    rhythmText: '{share} der Läufe waren am {dayLong}. Lieblingsstunde: {hour} Uhr.',
    rhythmCaption: 'Kreis: Läufe je Startzeit über 24 Stunden. Balken: Läufe je Wochentag.',
    bestKicker: 'Bestwerte',
    bestTitle: 'Was er draufhatte',
    bestTitleActive: 'Was er draufhat',
    fastestKm: 'schnellster Kilometer',
    longest: 'längster Lauf',
    typical: 'typische Einheit',
    avgHr: 'Ø Puls',
    wet: 'Läufe im Regen (von {of})',
    coldest: 'kältester Lauf',
    thanks: 'Danke für {km}.',
    still: 'Weiter so – noch {km} bis „Bald ersetzen".',
  },
  how: {
    profile: {
      label: 'Steckbrief: wie berechnet?',
      km: 'km: Laufen, Gehen und Wandern mit dem Schuh, plus die km, die er vorher schon hatte.',
      typical: 'Typisch: Median aus den Läufen mit dem Schuh, Strecke und Tempo getrennt. Gehen und Wandern zählen hier nicht mit.',
      pace: 'Tempo aus der Bewegungszeit (fehlt sie, aus der Gesamtzeit); unter 2:30 oder über 15:00 /km gilt als Messfehler.',
      daytime: 'Tageszeit nach der Startzeit: morgens 5–10 Uhr, mittags 11–13, nachmittags 14–16, abends 17–21, nachts 22–4.',
      rain: 'Regen: ab 0,2 mm Niederschlag während des Laufs (Open-Meteo am Startort). Gezählt werden nur Läufe mit Wetterdaten.',
      fastest: 'Schnellster km: schnellstes 1-km-Stück innerhalb eines Laufs, Pausen eingerechnet.',
      forecast: 'Prognose: die km der letzten 90 Tage, bei jüngeren Schuhen seit dem ersten Lauf (mit Gehen und Wandern) gleichmäßig weitergerechnet bis zur nächsten Grenze. Erst ab 3 Einheiten und 14 Tagen; mehr als 2 Jahre voraus gibt es keine.',
    },
    km: {
      lines: 'Je aktivem Schuh die km nach jedem Tag mit ihm, beginnend mit den km vorher. Laufen, Gehen und Wandern zählen.',
      forecast: 'Gestrichelt: die Prognose aus dem Steckbrief bis zur nächsten Grenze, mit Monat am Punkt.',
      band: 'Grauer Streifen: von der kleinsten bis zur größten km-Zahl, bei der du einen Schuh ausgemustert hast – nur Schuhe ab 300\u00a0km, und erst ab zwei solchen; kürzer gelaufene gelten als aussortiert, nicht als abgelaufen.',
      time: '„Wann im Einsatz": Balken vom ersten bis zum letzten Lauf; bei aktiven Schuhen zeigt die dünne Linie die Zeit seitdem.',
    },
    pace: {
      which: 'Nur Läufe, nur Schuhe ab 10 Läufen. Tempo je Lauf aus Bewegungszeit (sonst Gesamtzeit) und Strecke; unter 2:30 oder über 15:00 /km fällt als Messfehler weg.',
      bar: 'Balken: die mittlere Hälfte der Läufe – ein Viertel war schneller, ein Viertel langsamer.',
      median: 'Strich: Median – die Hälfte der Läufe war schneller, die Hälfte langsamer.',
    },
  },
  ask: {
    title: 'Nach dem Lauf fragen',
    sub: 'Hat ein neuer Lauf keinen Schuh, fragt „Heute" nach – auf Wunsch auch per Push.',
  },
  push: {
    title: 'Push auf diesem Gerät',
    sub: 'Nach einem neuen Lauf ohne Schuh kommt eine Nachricht, sonst nichts.',
    test: 'Testnachricht',
    testSent: 'Gesendet.',
    devices: { one: '{count} Gerät angemeldet', other: '{count} Geräte angemeldet' },
    unsupported: 'Dieser Browser kann keine Push-Nachrichten.',
    install: 'Auf dem iPhone geht Push erst, wenn dashy-dash installiert ist (siehe oben).',
    denied: 'Benachrichtigungen sind im Browser gesperrt – in den Website-Einstellungen erlauben.',
    hint: 'Android zeigt die zwei zuletzt genutzten Schuhe als Knöpfe in der Nachricht; auf dem iPhone öffnet ein Tipp die Karte.',
  },
  install: {
    title: 'Als App installieren',
    button: 'Installieren',
    prompt: 'Startet dann wie eine App, ohne Adressleiste.',
    done: 'Installiert – ab jetzt über das neue Symbol öffnen.',
    ios1: 'In Safari unten in der Leiste auf „Teilen" tippen:',
    ios2: 'In der Liste „Zum Home-Bildschirm" wählen (eventuell etwas nach unten wischen).',
    ios3: 'Oben rechts auf „Hinzufügen" tippen.',
    ios4: 'dashy-dash über das neue Symbol öffnen. Push für die Schuh-Frage dann unter „Ausrüstung" einschalten.',
    cardTitle: 'dashy-dash als App',
    why: 'Auf dem Home-Bildschirm startet dashy-dash wie eine App, ohne Adressleiste – und kann nach dem Lauf per Push nach dem Schuh fragen.',
    dismiss: 'Nicht mehr zeigen',
    shareIcon: 'Teilen-Symbol: Quadrat mit Pfeil nach oben',
    android: 'In Chrome oben rechts auf ⋮ tippen, dann „App installieren" oder „Zum Startbildschirm hinzufügen". Push geht auch ohne, direkt im Browser.',
    desktop: 'In Chrome oder Edge rechts in der Adressleiste auf das Installieren-Symbol klicken; in Safari am Mac Ablage → „Zum Dock hinzufügen".',
  },
  prompt: {
    title: 'Welcher Schuh?',
    skip: 'Ohne Schuh',
    later: 'Später fragen',
    more: { one: 'Danach fragt die Karte noch nach {count} Lauf.', other: 'Danach fragt die Karte noch nach {count} Läufen.' },
    otherAnswers: 'Oder:',
    saved: '{name} eingetragen',
  },
  activity: {
    label: 'Schuh',
    none: 'Keiner',
    manage: 'Ausrüstung',
  },
};
